// hooks/useFormViewerWizard/step1Aftermath.ts — Efek samping pasca-insert step 1.
// Counter, tracking, cart-cleanup, sesi resume (orderId+csId+tanda keranjang).
// Semua best-effort: gagal = order tetap jadi, sweep yang menambal.
// Revisi 2026-10-20 (kasus Viral.Ltd): Lead CAPI fire DI SINI — order step-1 bisa
// closing/CS-manual TANPA step 3 & thanks page (sumber nol-Lead). Dedup otomatis:
// event_id = orderId sama di step-1, complete, & browser thanks.
import { supabase } from '../../../../supabase/client';
import { normalizePhoneForDb } from '../../../../utils/formatPhone';
import { trackFormSubmit } from '../../../../utils/trackingUtils';
import { storePhoneLast4 } from '../../../../hooks/useThankYouPage/fetchOrder';
import { fireCapiEvents } from '../useFormViewer/submitCapi';
import { buildStep1Sig } from './step1Sig';

export async function runStep1Aftermath(args: { hook: any; form: any; built: any; orderData: any }): Promise<void> {
    const { hook, form, built, orderData } = args;
    try {
        const linkLeadId = sessionStorage.getItem('leadOrderLink');
        if (linkLeadId) {
            sessionStorage.removeItem('leadOrderLink');
            supabase.rpc('link_lead_order', { p_lead_id: linkLeadId, p_order_id: orderData.id }).then(() => {}, () => {});
        }
    } catch { /* abaikan */ }
    if (form?.id) { try { await supabase.rpc('increment_form_submission', { p_form_id: form.id }); } catch { /* */ } }
    trackFormSubmit(
        form?.id || '', form?.title || '', orderData.id, form?.productId || '',
        built.productName, built.brandId, built.phone, built.email, built.name,
        undefined, hook.quantity, Number(built.pOrder?.totalPrice) || 0,
    );
    storePhoneLast4(orderData.id, built.phone);
    // Lead = order baru Pending — fire sejak step 1 (best-effort, tak gagalkan order).
    try {
        fireCapiEvents({
            globalTrackingSettings: hook.globalTrackingSettings, form, phone: built.phone,
            email: built.email, name: built.name, sellingPrice: built.sellingPrice,
            shippingCost: 0, codFee: 0, productName: built.productName,
            orderData: { id: orderData.id }, orderValue: Number(built.pOrder?.totalPrice) || 0,
            customerCity: built.city || undefined, customerProvince: built.province || undefined,
            customerPostalCode: (built.pOrder as any)?.postalCode || undefined,
        });
    } catch { /* abaikan — browser thanks + sweep tetap jalan */ }
    try {
        const sCartId = sessionStorage.getItem(`abandonedCart_${form?.id}`);
        if (sCartId) {
            try { await supabase.rpc('cleanup_abandoned_cart', { p_cart_id: sCartId, p_phone: normalizePhoneForDb(built.phone), p_form_id: form?.id || null }); } catch { /* */ }
            sessionStorage.removeItem(`abandonedCart_${form?.id}`);
        }
    } catch { /* abaikan */ }
    try {
        sessionStorage.setItem(`wizardOrder_${form?.id}`, JSON.stringify({
            orderId: orderData.id, csId: built.assignedCsId || null,
            sig: buildStep1Sig(hook),
        }));
    } catch { /* abaikan */ }
    // Order sudah ada di DB → hentikan cart hantu (debounce 5 dtk + beforeunload
    // effectsCart hanya baca flag ini; alur wizard tak pernah set sebelumnya).
    try { (hook as any).hasSubmittedRef.current = true; } catch { /* abaikan */ }
}
